export default __webpack_public_path__ + "static/media/etachrom.b63ecee8.png";